import { app } from '../../../bootstrap/core';
import positionsComponent from './positions.component';

app.component('positions', positionsComponent);



// WEBPACK FOOTER //
// ./src/app/common/ui/positions/positions.js